import React from 'react';
import './WholeProcess.scss';
import { Lists, HeaderSwiper, ColList } from '@/components/mixins'
import '../../common/common.scss'
import { RelatedCases } from '@/components'
class WholeProcess extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      headerDataLists: [
        { imgPath: require("img/Products/processbanner.png"), imgHDPath: `${require("img/Products/processbanner.png")} 1x,${require("img/Products/processbanner@2x.png")} 2x,${require("img/Products/processbanner@3x.png")} 3x`, attachURL: "/" }
      ],
      productSpecial: [
        { imgPath: require("img/Products/special.png"), imgHDPath: `${require("img/Products/special.png")} 1x,${require("img/Products/special@2x.png")} 2x,${require("img/Products/special@3x.png")} 3x`, attachURL: "/" }
      ],
      ColIconData: [
        {
          imgPath: require("img/Products/WholeProcess-icon03.png"), imgHDPath: `${require("img/Products/WholeProcess-icon03.png")} 1x,${require("img/Products/WholeProcess-icon03@2x.png")} 2x,${require("img/Products/WholeProcess-icon03@3x.png")} 3x`,
          title: '代理'
        },
        {
          imgPath: require("img/Products/WholeProcess-icon02.png"), imgHDPath: `${require("img/Products/WholeProcess-icon02.png")} 1x,${require("img/Products/WholeProcess-icon02@2x.png")} 2x,${require("img/Products/WholeProcess-icon02@3x.png")} 3x`,
          title: '鉴证'
        },
        {
          imgPath: require("img/Products/WholeProcess-icon01.png"), imgHDPath: `${require("img/Products/WholeProcess-icon01.png")} 1x,${require("img/Products/WholeProcess-icon01@2x.png")} 2x,${require("img/Products/WholeProcess-icon01@3x.png")} 3x`,
          title: '咨询'
        },

      ],
      dataLists: [
        {
          title: '决策阶段',
          data: '规划、策划咨询；项目建议书、可行性研究报告；投融资策划；各类专项评估；投资估算、PPP咨询',
        },
        {
          title: '设计阶段',
          data: '各阶段设计；设计咨询、管理；概预算编审',
        },
        {
          title: '施工准备阶段',
          data: '项目实施策划；项目制度建设；报批报建；采购与招标代理；预算及清单控制价编制',
        },
        {
          title: '施工阶段',
          data: '工程监理；造价管理；现场项目管理；工程结算；竣工财务决算',
        },
        {
          title: '运营阶段',
          data: '绩效评价；后评价',
        },
        {
          title: '工程项目全建设周期',
          data: '青矩提供涵盖投资咨询、设计、招标代理、造价咨询、BIM 咨询、项目管理、全咨云平台等有机结合的全过程咨询工程服务。',
        },
      ],
      caseList: [
        {
          imgs: require("img/Products/pic1.png"), name: "爱尔总部大厦工程",
        },
        {
          imgs: require("img/Products/pic2.png"), name: "京沪高速铁路",
        },
        {
          imgs: require("img/Products/overall3.png"), name: "新东方合肥总部工程",
        },
      ]
    }
  }
  render() {
    return (
      <main>
        <HeaderSwiper headerDataLists={this.state.headerDataLists}></HeaderSwiper>
        <div className='WholeProcess'>
          {/* <h5 className='product-title'>产品特色</h5>
          <div className='special-img'>
            {
              this.state.productSpecial.map((item, index) =>
                <img key={index} src={item.imgPath} alt=""
                srcSet={item.imgHDPath} width="100%" height="100%" />
              )
            }
          </div> */}
          <h5 className='product-title mode-title'>服务类型</h5>
          <ColList ColIconData={this.state.ColIconData} className="collist"></ColList>
          <h5 className='product-title content-title'>服务内容</h5>
          <Lists dataLists={this.state.dataLists}></Lists>
          <RelatedCases caseList={this.state.caseList} id={'WholeProcess'} />
        </div>
      </main>
    )
  }
}
export default WholeProcess;
